import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import createStore from './store/createStore';
import App from './components/organisms/App/App';
import { overrideConfigFromParams } from './helpers/config';
import './i18n/setup';
import debugTools from './helpers/debugTools';

import './styles/theme.css';
import './styles/global.css';
import './styles/toast.css';

const idSite = overrideConfigFromParams(new URLSearchParams(window.location.search));

const store = createStore(idSite);

debugTools(store);

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

window.store = store;
